// extracted by mini-css-extract-plugin
module.exports = {"slide":"slide_slide__2G9WI","slideWrapper":"slide_slideWrapper__34HMb","slideMover":"slide_slideMover__QWy9B","slideNav":"slide_slideNav__2GB7h"};